import { AssetType } from '@arcxgame/contracts/dist/arc-types/core'
import { BigNumber } from 'ethers'

import { BASE } from '../constants/crypto'

export function calculateCollateralRatio(
  collateralAsset: AssetType,
  collateralAmount: BigNumber,
  borrowedAmount: BigNumber,
  currentPrice: BigNumber,
): BigNumber {
  let borrowedValue: BigNumber
  let collateralValue: BigNumber

  if (borrowedAmount.isZero() || currentPrice.isZero() || collateralAmount.isZero()) {
    return BigNumber.from(0)
  }

  if (collateralAsset === AssetType.Collateral) {
    borrowedValue = BigNumber.from(borrowedAmount)
      .mul(BASE)
      .div(currentPrice || 0)

    collateralValue = BigNumber.from(collateralAmount || 0)
  }

  if (borrowedValue.isZero() || !borrowedValue) {
    return BigNumber.from(100)
  }

  if (collateralValue.isZero() || !collateralValue) {
    return BigNumber.from(0)
  }

  return BigNumber.from(collateralValue).mul(100).div(borrowedValue)
}
